import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
// import VendorDashboard from 'views/vendor/dashboard';
import VendorWallet from 'views/vendor/wallet';
// import VendorTransactions from 'views/vendor/wallet/UserTransactions';
import VendorProfile from 'views/vendor/settings/VendorProfile';
import VendorSettings from 'views/vendor/settings';
import VendorProducts from 'views/vendor/products';
import VendorCreateProduct from 'views/vendor/products/CreateProduct';
import VendorUpdateProduct from 'views/vendor/products/UpdateProduct';
import ProductDetail from 'views/vendor/products/ProductDetail';
import VendorOrders from 'views/vendor/order';
import VendorOrderDetail from 'views/vendor/order/OrderDetail';
// import VendorEditOrder from 'views/vendor/order/EditOrder';
import ProductCategory from 'views/vendor/product-category/ProductCategory';
import PayoutPage from 'views/vendor/payouts/PayoutPage';
import VendorTransactions from 'views/vendor/transaction/VendorTransactions';
import NotificationPage from 'views/common/notifications/NotificationPage';
import VendorStaffList from 'views/vendor/staffs/VendorStaffList';
import VendorKycSubmission from 'views/vendor/kyc/KycSubmission';
import VendorSalesReport from 'views/vendor/reports/VendorSalesReport';
import KycGuard from 'ui-component/KycGuard';

// dashboard routing
const VendorDashboard = Loadable(lazy(() => import('views/vendor/dashboard')));
// ==============================|| MAIN ROUTING ||============================== //
const prefix = 'vendor';
const VendorRoutes = [
    {
        path: '',
        element: <VendorDashboard />,
        prefix
    },
    {
        path: 'dashboard',
        element: <VendorDashboard />,
        prefix
    },
    {
        path: 'products',
        element: <KycGuard><VendorProducts /></KycGuard>,
        prefix
    },
    {
        path: 'products/:id',
        element: <KycGuard><ProductDetail /></KycGuard>,
        prefix
    },
    {
        path: 'products/create',
        element: <KycGuard><VendorCreateProduct /></KycGuard>,
        prefix
    },
    {
        path: 'products/:id/edit',
        element: <KycGuard><VendorUpdateProduct /></KycGuard>,
        prefix
    },
    {
        path: 'orders',
        element: <VendorOrders />,
        prefix
    },
    {
        path: 'orders/:id',
        element: <VendorOrderDetail />,
        prefix
    },
    // {
    //     path: 'orders/:id/edit',
    //     element: <KycGuard><VendorEditOrder /></KycGuard>,
    //     prefix
    // },
    {
        path: 'categories',
        element: <KycGuard><ProductCategory /></KycGuard>,
        prefix
    },
    {
        path: 'payouts',
        element: <KycGuard><PayoutPage /></KycGuard>,
        prefix
    },
    {
        path: 'wallet',
        element: <KycGuard><VendorWallet /></KycGuard>,
        prefix
    },
    {
        path: 'transactions',
        element: <KycGuard><VendorTransactions /></KycGuard>,
        prefix
    },
    {
        path: 'profile',
        element: <VendorProfile />,
        prefix
    },
    {
        path: 'settings',
        element: <VendorSettings />,
        prefix
    },
    {
        path: 'notifications',
        element: <NotificationPage />,
        prefix
    },
    {
        path: 'staffs',
        element: <KycGuard><VendorStaffList /></KycGuard>,
        prefix
    },
    {
        path: 'kyc',
        element: <VendorKycSubmission />,
        prefix
    },
    {
        path: 'reports/sales',
        element: <KycGuard><VendorSalesReport /></KycGuard>,
        prefix
    }
];

export default VendorRoutes;
